<template>
  <mx-cells :config="Config" v-if="value" border="0">
    <div slot-scope="data" style="text-align: left" class="p1 flex-row start middle"
      v-show="GetShowState(data.cell.field)">
      <div style="margin-right: 16px; min-width: 32px" :class="data.cell.field && data.cell.field.Req ? 'req' : 'noreq'"
        :style="data.cell.titleStyle || { width: '64px', textAlign: 'right' }" v-if="!data.cell.hideTitle">
        {{ data.cell.title }}
      </div>
      <template v-if="data.cell.field">
        <mx-field :config="data.cell.field" :value="value" :ref="'field_' + data.cell.field.Name" :edit="true"
          :type="data.cell.field.Type" :name="data.cell.field.Name" @change="handleChange" :checkable="true"
          :style="data.cell.fieldStyle || { flex: 1 }">
        </mx-field>
        <el-tooltip v-if="GetFieldError(data.cell.field)" style="margin-left: 4px;"
          :content="GetFieldError(data.cell.field).message" placement="bottom">
          <i class="el-icon-warning" style="color: red"> </i>
        </el-tooltip>
      </template>
    </div>
  </mx-cells>
</template>
<script>
import form from 'matrix.node.ui/master/form'
export default {
  mixins: [form.component],
  props: {
    layout: Object
  },
  computed: {
    Config() {
      let layout = this.layout || this.$matrix.Config.Layout[this.config.Type] || { type: 'row', items: [] }
      layout = JSON.parse(JSON.stringify(layout))
      let fields = [].concat(this.columns || [])
      let foo = (cell) => {
        if (cell.items) { cell.items = cell.items.map(item => { return foo(item) }).filter(item => { return item }) }
        else {
          if (typeof cell === 'string') cell = { title: cell }
          let index = fields.findIndex(col => { return col.Title === cell.title || col.Name === cell.name })
          if (index > -1) {
            cell.field = fields[index]
            fields.splice(index, 1)
          }
        }
        return cell
      }
      layout = foo(layout)
      let index = 0;
      let row = null
      let doField = (field => {
        if (index == 0) {
          row = { type: 'col', items: [] }
          layout.items.push(row)
        }
        let col = 1;
        const types = ['Html', 'Image', 'Images', 'File', 'Files', 'Json', 'Role', 'Enums']
        if (types.indexOf(field.Type) > -1 || field.Length >= 200 || field.ForOneLine) {
          row = { type: 'col', items: [] }
          layout.items.push(row)
          row.items.push({ title: field.Title, field: field, fieldStyle: { flex: 1 }, titleStyle: { width: '64px', textAlign: 'right' } })
          col = 2
        } else {
          if (field.Title.length <= 4) {
            row.items.push({ title: field.Title, field: field, style: { width: '50%' }, fieldStyle: { flex: 1 }, titleStyle: { width: '64px', textAlign: 'right' } })
          } else {
            row = { type: 'col', items: [] }
            layout.items.push(row)
            col = 2
            row.items.push({ title: field.Title, field: field, fieldStyle: { flex: 1 }, titleStyle: { textAlign: 'left' } })
          }
        }
        index += col
        if (index >= 2) index = 0
      })
      fields.filter(field => { return !field.NoShow }).forEach(field => {
        doField(field)
      })
      fields.filter(field => { return field.NoShow }).forEach(field => {
        doField(field)
      })
      return layout
    }
  },
  methods: {
    GetFieldError(col) {
      if (this.Errors && this.Errors.length > 0) {
        return this.Errors.find((e) => {
          return e.name === col.Name
        })
      }
    },
    handleChange2(val) {
      if (val.name && this.Errors) {
        this.Errors = this.Errors.filter((e) => {
          return e.name !== val.name
        })
      }
    },
    GetSelfValue() {
      return Object.assign({}, this.value, this.GetValue({}))
    }
  }
}
</script>
<style scoped>
.errorTitle {
  color: red;
  font-size: 14px;
  margin-top: 5px;
  text-align: left;
  height: 16px;
}

.req {
  position: relative;
}

.req::after {
  position: absolute;
  content: "*";
  top: 5px;
  right: -8px;
  color: red;
}

.title {
  word-break: keep-all;
  /* 不换行 */
  white-space: nowrap;
  /* 不换行 */
}

.panel10lr {
  padding: 2px 0px;
}

.box {
  flex: 1;
  text-align: left;
  padding: 5px;
}

.box .mask {
  opacity: 0.5;
  background-color: #eee;
  padding: 5px;
}
</style>
